import axios from "axios";

class BaseService {

	/**
	 * React Component that is instantiating this service
	 * @type {React.Component}
	 */
	component = null;

	/**
	 * Set react component on object construction, so later can be used by its services
	 * @param component React.Component that is instantiating this service
	 */
	constructor(component) {
		this.component = component;
	}

	baseServicePath = () => null

	/**
	 * launch a get request to baseServicePath and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param pageNr to get, default 1
	 */
	index = (pageNr = 1, options = null) => {
		if (this.baseServicePath() != null) {
			if (options) {
				return axios.get(`${this.baseServicePath()}?page=${pageNr}&${options}`);
			}
			return axios.get(`${this.baseServicePath()}?page=${pageNr}`);
		}
		throw new Error("baseServicePath is not defined");
	}

	/**
	 * launch a get request to baseServicePath and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param pageNr to get, default 1
	 */
	search = (term = null, hasParams = false) => {
		if (this.baseServicePath() != null) {
			if(hasParams) {
				return axios.get(`${this.baseServicePath()}?term=${term}&${hasParams}`);
			}
			return axios.get(`${this.baseServicePath()}?term=${term}`);
		}
		throw new Error("baseServicePath is not defined");
	}

	/**
	 * launch a get request to baseServicePath and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param pageNr to get, default 1
	 */
	searchByAttribute = (attribute, value, extra) => {
		if (this.baseServicePath() != null) {
			if(extra) {
				return axios.get(`${this.baseServicePath()}?${attribute}=${value}&${extra}`);
			}
			return axios.get(`${this.baseServicePath()}?${attribute}=${value}`);
		}
		throw new Error("baseServicePath is not defined");
	}

	/**
	 * launch a get request to baseServicePath to get a resource by id and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param id of resource to get
	 */
	show = (id, extra) => {
		if (this.baseServicePath() != null) {
			if(extra) {
				return axios.get(`${this.baseServicePath()}/${id}/${extra}`);			
			}
			return axios.get(`${this.baseServicePath()}/${id}`);
		}
		throw new Error("baseServicePath is not defined");
	}

	/**
	 * launch a post request to baseServicePath to store a resource and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param data/form to be stored
	 */
	store = (data, multipart = false) => {
		let config = {};
		if (multipart) {
			config = {
				headers: {
					"Content-Type": "multipart/form-data;"
				}
			};
		}

		if (this.baseServicePath() != null) {
			return axios.post(this.baseServicePath(), data, config);
		}
		throw new Error("baseServicePath is not defined");
	}

	/**
	 * launch a put request to baseServicePath to update a resource and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param id of resource to be updated
	 * @param data/form to be updated
	 */
	update = (id, data) => {
		if (id) {
			if (this.baseServicePath != null) {
				return axios.put(`${this.baseServicePath()}/${id}`, data);
			}
			throw new Error("baseServicePath is not defined");
		} else {
			if (this.baseServicePath != null) {
				return axios.put(`${this.baseServicePath()}`, data);
			}
			throw new Error("baseServicePath is not defined");
		}
	}

	/**
	 * launch a delete request to baseServicePath to delete a resource by id and returns axios object with error handling defined,
	 * to get results, a .then() block need to be added
	 * @param id of resource to be deleted
	 */
	delete = (id, extra) => {
		if (this.baseServicePath != null) {
			if(extra) {
				return axios.delete(`${this.baseServicePath()}/${id}/${extra}`);
			}
			return axios.delete(`${this.baseServicePath()}/${id}`);
		}
		throw new Error("baseServicePath is not defined");
	}
}

export default BaseService;


// WEBPACK FOOTER //
// ./src/services/BaseService.js